import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IRunUserIdentityMigrationBackgroundJobNowParams {
}

export class RunUserIdentityMigrationBackgroundJobNowRequest extends Request<IRunUserIdentityMigrationBackgroundJobNowParams, IResult> {
  constructor(params: IRunUserIdentityMigrationBackgroundJobNowParams = {}) {
    super('runUserIdentityMigrationBackgroundJobNow', params);
  }
}
